module.exports = __webpack_public_path__ + "static/media/texture-season-10.9a4a1da4.jpg";